import React from 'react'
import { Placeholder, Spinner } from '@wordpress/components';
import useSettings from '../utils/useSettings';
import { Blocks, Integrations } from '../pages/_index';
const Main = (props) => {
  const {activeTab, setActive } = props;
  const [getOption, updateOption, status] = useSettings();
  // if ("loading" === status) {
  //   return (
  //     <Placeholder>
  //       <Spinner />
  //     </Placeholder>
  //   );
  // }

  const Content = () => {
    switch (activeTab) {
      case "":
        return <Blocks />;
      case "integrations":
        return (
          <div className="slideverse-left">
            <Integrations />
          </div>
        );
      case "blocks":
        return <Blocks />;
      default:
        return <div className="slideverse-left">empty</div>;
    }
  };
  return (
    <>
      <div className="slideverse-main is-blocks">
        <Content />
      </div>
    </>
  );
};

export default Main